import { Component, inject, ViewEncapsulation } from '@angular/core';
import { DuditModalData } from '../dudit.component';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'wfs-dudit-drug-modal',
  templateUrl: './dudit-drug-modal.component.html',
  styleUrls: ['./dudit-drug-modal.component.scss'],
  encapsulation: ViewEncapsulation.None, // makes styling applicable globally but only for this component
  imports: [FormButtonComponent, MatDialogModule]
})
export class DuditDrugModalComponent {
  readonly #data = inject<DuditModalData[]>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef);

  readonly drugs = this.#data?.at(0);
  readonly tablets = this.#data?.at(1);
  readonly painkillers = this.#data?.at(2);
  readonly sedatives = this.#data?.at(3);
  readonly adhd = this.#data?.at(4);

  // Method to calculate the split index for painkillers and sedatives (so the right values go to the right column)
  getSplitIndex(arrayLength: number): number {
    return Math.ceil(arrayLength / 2);
  }

  close(): void {
    this.#dialogRef.close();
  }
}
